import { axiosGET, axiosPOST } from '../../Helpers/TypeAxios'
import { urlParseParams } from "../../Helpers/helpFunction";

const routerRoot = 'market';

export default class Market {
  marketWorld(assetType: string, data?: any) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/world/asset/${assetType}?${stringUrl}`, {})
  }
  marketVietName(data?: any) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/vietnam/valuation?${stringUrl}`, {})
  }
  marketTrading(data?: any) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/vietnam/trading?${stringUrl}`, {})
  }
  marketCashflow(data?: any) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/vietnam/cashflow?${stringUrl}`, {})
  }
  marketCashflowIndustry(icbcode: string) {
    return axiosGET(`/${routerRoot}/vietnam/cashflow/industry/${icbcode}`, {})
  }
  marketCashflowStockCode(stockcode: string) {
    return axiosGET(`/${routerRoot}/vietnam/cashflow/stock/${stockcode}`, {})
  }
  marketTransprobability(data?: any) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/vietnam/transprobability?${stringUrl}`, {})
  }
}
